import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import { jsx as _jsx } from "react/jsx-runtime";
import { useTheme } from "@react-navigation/native";
import * as React from "react";
import { Animated, Platform, StyleSheet } from "react-native";
export default function HeaderBackground(_param) {
    var style = _param.style, rest = _object_without_properties(_param, [
        "style"
    ]);
    var colors = useTheme().colors;
    return /*#__PURE__*/ _jsx(Animated.View, _object_spread({
        style: [
            styles.container,
            {
                backgroundColor: colors.card,
                borderBottomColor: colors.border,
                shadowColor: colors.border
            },
            style
        ]
    }, rest));
}
var styles = StyleSheet.create({
    container: _object_spread({
        flex: 1
    }, Platform.select({
        android: {
            elevation: 4
        },
        ios: {
            shadowOpacity: 0.85,
            shadowRadius: 0,
            shadowOffset: {
                width: 0,
                height: StyleSheet.hairlineWidth
            }
        },
        default: {
            borderBottomWidth: StyleSheet.hairlineWidth
        }
    }))
});
